module.exports = __webpack_public_path__ + "static/media/ardor.1230db21.gif";